import React, { useEffect, useContext, useState } from "react";
import { fetchJson } from "../fetch.js";
import { useElasticData, useExtraData } from "./DataContext.js";
import OtherEditions from './OtherEditions.js';
import { SearchContext } from "../components/SearchContext.js";

const BookProperties = () => {

    let { bindings, bookBands, isbn, keywords, ksGroupsData, altEditions } = useElasticData();
    let {  _source, isGuestUser, isSchoolsUser } = useExtraData();
    let { doCustomSearch, doSearchTermSearch } = useContext(SearchContext);

    const _s = _source;
    const bookpageProductId = _s.id;

    const [keywordProductCountData, setKeywordProductCountData] = useState(null);

    // Book page html
    useEffect(() => {
        // Get keyword product count
        const fetchKeywordProductCount = (kIds) => {
            fetchJson("/tag/getKeywordTitleCounts/" + kIds).then((json) => {
                var results = json;
                setKeywordProductCountData(results);
            });
        }

        if(_s.keywords?.length > 0) {
            var keywordIds = _s.keywords.map((k) => k.value);
            fetchKeywordProductCount(keywordIds.join(","));
        }
    }, [bookpageProductId]);

    const suitability = (ksGroupsData) => {
        let heading, subheading = [], phrase = "";

        let primarySubheadings = ["KS1", "KS2", "KS2 Lower", "KS2 Upper", "EYFS", "Foundation", "Reception", "Year 1", "Year 2", "Year 3", "Year 4", "Year 5", "Year 6"];

        if (ksGroupsData?.length > 0) {
            ksGroupsData?.forEach(ks => {
                if (ks.ctParent == '0') {
                    heading = ks.ctTitle;
                } else {
                    subheading.push(ks.ctTitle);
                }
            });

            if (!heading) {
                if (primarySubheadings.some(r=> subheading.includes(r))) {
                    heading = "Primary";
                } else {
                    heading = "Secondary";
                }
            }

            phrase = `${heading} ${heading && subheading.length ? `(${subheading.join(',')})` : ''}`
        }

        return phrase;
    }

    const bibText = (_s.bib_tag && _s.bib_tag !== "" && _s.bib_tag?.length > 300) ? (_s.bib_tag.substring(0, 300).trim() + "...") : _s.bib_tag;

    const format = _source.broad_binding != "O" && broadbindings ? broadbindings[_source.broad_binding] : bindings[_source.binding];

    const bookBand = _source.productcategorylinks ? _source.productcategorylinks.filter(c => bookBands[c]).map(c => c) : "";

    const bookbandsArray = _source.productcategorylinks ? _source.productcategorylinks.filter(c => bookBands[c]).map(c => <li><span value={[c]} className={`listPageCircle swatch cat${c}`} title={bookBands[c]}></span></li>) : [];

    const keywordsSorted = _s.keywords?.sort((a, b) => a.title.localeCompare(b.title));

    return (
        <>
            {_s.isbookpack != 1 && <div>
                {_s.schools_only_review && !isGuestUser && isSchoolsUser ? <p className="topReview">{_s.schools_only_review}</p> : _s.evaluation && <p className="topReview">{_s.evaluation}</p>}
            </div>}
            <div className="annotPadding" style={{whiteSpace:'pre-line'}}>
                {bibText && bibText !== "" && <div className="bibTag">{bibText}</div>}
                {_s.isbookpack == 1 && _s.annotation && <>
                    <br/><div className="additionalAnnotation">{_s.annotation}</div>
                </>}
            </div>
            {_s.isbookpack != 1 && <div className="properties">
                {_s.series_display && <p><strong>Series</strong>&nbsp;&nbsp;<span><a className="blue" onClick={e => {
                    e.preventDefault();
                    doSearchTermSearch(`"${_s.series_display}"`, "series");
                }}>{_s.series_display} {`${_s.volume ? `(${_s.volume})` : ''}`}</a></span></p>}
                {_s.binding && <p><strong>Format</strong>&nbsp;&nbsp;<span>{format}</span></p>}
                {isbn && <p><strong>ISBN</strong>&nbsp;&nbsp;<span>{isbn}</span></p>}
                {_s.publish_date && <p><strong>Publication Date</strong>&nbsp;&nbsp;<span>{new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium' }).format(new Date(_s.publish_date))}</span></p>}
                {_s.peters_subject && <p><strong>Subject</strong>&nbsp;&nbsp;<span>{_s.peters_subject}</span></p>}
                {ksGroupsData.length > 0 && <p><strong>Suitable for</strong>&nbsp;&nbsp;<span>{suitability(ksGroupsData)}</span></p>}
                {(_s.book_level > 0 || _s.ar_interest_level) && <p>
                    <span className="arLevelLabel"><strong>AR</strong></span>&nbsp;&nbsp;<span>
                        <a className="arLevel" title="Click to search for other books at this level" href="#" onClick={e => {
                            e.preventDefault();
                            doCustomSearch([
                                { "filter": 'filters[acceleratedReader][bookLevel][bookLevelFrom]', value: Math.floor(_s.book_level) },
                                { "filter": 'filters[acceleratedReader][bookLevel][bookLevelTo]', value: Math.ceil(_s.book_level + 0.1) - 0.1 },
                                { "filter": `filters[acceleratedReader][interestLevel][${_s.ar_interest_level}][checked]`, "value": "1" }])
                        }} >{_s.book_level > 0 && `Reading level ${_s.book_level.toFixed(1).toString()}`}{(_s.book_level > 0 && _s.ar_interest_level) && `, `}{_s.ar_interest_level && `Interest level ${_s.ar_interest_level}`}&nbsp;</a>
                    </span>
                </p>}
                {isGuestUser && bookbandsArray.length > 0 && <div className="loginRequired"><a className="login">Log in</a> to view book bands.</div>}
                {!isGuestUser && bookbandsArray.length > 0 && <p className="bookBandContainer">
                    {bookbandsArray.length > 1 ? <>
                        <span className="bandLabel"><strong>Book bands</strong>&nbsp;</span>
                        <a className="bookBands" title="Click to search for other books at these bands" href="#" onClick={e => {
                            e.preventDefault();
                            doCustomSearch([{ "filter": `filters[bookBand][${bookBand[0]}][checked]`, "value": "1" }, { "filter": `filters[bookBand][${bookBand[1]}][checked]`, "value": "1" }]);
                        }}>
                            <ul>{bookbandsArray}</ul>
                        </a>
                    </> : <>
                        <span className="bandLabel"><strong>Book band</strong>&nbsp;</span>
                        <a className="bookBands" title="Click to search for other books at this band" href="#" onClick={e => {
                            e.preventDefault();
                            doCustomSearch([{ "filter": `filters[bookBand][${bookBand}][checked]`, "value": "1" }]);
                        }}>
                            <ul>{bookbandsArray}</ul>
                        </a>
                    </>}
                </p>}
                {isGuestUser && _s.phonic_phase_level && <div className="loginRequired"><a className="login">Log in</a> to view phonic phase.</div>}
                {!isGuestUser && _s.phonic_phase_level && <p>
                    <span className="phonicPhaseLabel"><strong>Phonic phase</strong></span>&nbsp;&nbsp;<span>
                        <a className="phonicPhase" title="Click to search for other books at this phonic phase" href="#" onClick={e => {
                            e.preventDefault();
                            doCustomSearch([
                                { "filter": `filters[phonic][${_s.phonic_phase_level}][checked]`, "value": "1" }])
                        }} >{_s.phonic_phase_level}&nbsp;</a>
                    </span>
                </p>}
                {isGuestUser && _s.keywords?.length > 0 && <div className="loginRequired"><a className="login">Log in</a> to view theme keywords.</div>}
                {!isGuestUser && _s.keywords?.length > 0 && <p><strong>Keywords</strong>&nbsp;&nbsp;{keywordsSorted.map((k, i, ks) => <><span key={i} title={keywordProductCountData && `Browse ${parseInt(keywordProductCountData[k.value] - 1).toLocaleString()} other titles with this keyword`}><a onClick={e => {
                    e.preventDefault();
                    doCustomSearch([{ filter: "filters[keywords][selectedKeyword]", value: k.value }]);
                }}>{keywords[k.value]}</a></span>{`${i < ks.length - 1 ? ', ' : ''}`}</>)}</p>}
            </div>}
            {altEditions.length > 0 && <div className="altEditionsContainer"><OtherEditions /></div>}
        </>
    );
}

export default BookProperties;